import React, { Component } from 'react';

import { renderTableHeader, handleOkButtonClick } from './tableHelper';

import formFields from '../../util/formFields';
import './tables.css';

export class CSRAgentsResults extends Component {
  state = {
    selected: '',
  };

  renderTableBody(data) {
    return data.map((row, index) => {
      return (
        <tr key={index}>
          {formFields.csrAgentListTableHeaders.map(col => {
            if (col.dataField === 'selectors') {
              row[col.dataField] = (
                <input
                  id={'option-1'}
                  name={'agent-list'}
                  type={'radio'}
                  data-value={index}
                  key={index}
                  onClick={e => {
                    this.selectAgent(e);
                  }}
                />
              );
            }
            return <td key={col.text}>{row[col.dataField]}</td>;
          })}
        </tr>
      );
    });
  }

  selectAgent(e) {
    let selectedAgent = e.target;
    this.setState(() => ({
      selected: selectedAgent,
    }));
  }

  render() {
    const { selected } = this.state;
    const { data, okButtonClick, removeAgent } = this.props;
    const { csrAgentListTableHeaders: headerData } = formFields;
    return (
      <div className="agent-list-container">
        <h2 className="searchFormTitle">Search Results: Select a User and Click Ok</h2>
        <table>
          <thead>
            <tr>{renderTableHeader(headerData)}</tr>
          </thead>
          <tbody>{this.renderTableBody(data)}</tbody>
        </table>
        <div className="agent-list-button-container">
          <button
            name="okButton"
            className="search-button mrg-rgt"
            disabled={!selected}
            onClick={() => handleOkButtonClick(data, selected, okButtonClick)}
          >
            OK
          </button>
          <button name="backButton" className="search-button" onClick={() => removeAgent()}>
            BACK
          </button>
        </div>
      </div>
    );
  }
}
